import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { routeAssignmentEventRefs } from "../subjects/routeAssignmentEvent/refs";

/**
 * The driver accepted a route assignment.
 */
export const routeAcceptedV1 = tmsEventKind(
  { category: "routeAssignment", kind: "routeAccepted", version: 1 },
  {
    refs: routeAssignmentEventRefs,
    facts: {
      orderNumber: z.string(),
      /** The route assignment was accepted as a team rather than by one driver. */
      isTeam: z.boolean(),
    },
  },
);

export const RouteAcceptedV1Schema = routeAcceptedV1.schema;
export const RouteAcceptedV1FactsSchema = routeAcceptedV1.facts;

export type RouteAcceptedV1 = z.infer<typeof RouteAcceptedV1Schema>;
export type RouteAcceptedV1Facts = z.infer<typeof RouteAcceptedV1FactsSchema>;

/** Every version of `routeAccepted`, keyed by version. What `catalog.ts` places under `routeAssignment`. */
export const routeAccepted = { 1: routeAcceptedV1 } as const;
